// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-9fb49d22] .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {\n  background-color: rgba(0, 0, 0, 0.12) !important;\n}", ""]);
// Exports
module.exports = exports;
